import React from "react";
import moment from "moment";
import { Tooltip } from "react-tooltip";
import dangerSign from "../assets/img/danger-sign.svg";

const getCallerLabel = (call) => (
    call?.User?.fullName
    || call?.SrmIpRoomServiceMapping?.SrmIpRoom?.patientRoomName
    || "Unknown caller"
);

const StoreQueueCard = ({ call, index, onJoin, onReject }) => {
    const isEmergency = call?.callPriority === 2;
    const roomId = call?.SrmIpRoomServiceMapping?.SrmIpRoom?.patientRoomId;
    const relativeTime = call?.createdAt ? moment(call.createdAt).fromNow() : "";
    const attendClass = `store-attend-tooltip-${index}`;
    const rejectClass = `store-reject-tooltip-${index}`;

    return (
        <div className={`store-queue-card ${isEmergency ? "store-queue-card--emergency" : ""}`}>
            <div className="store-queue-card__info">
                <div className="store-queue-card__title-row">
                    {isEmergency ? <img className="emergency-call" src={dangerSign} alt="Emergency" /> : null}
                    <p className="store-queue-card__name">{getCallerLabel(call)}</p>
                    {isEmergency ? <span className="store-queue-card__badge">Emergency</span> : null}
                </div>
                {roomId ? <p className="store-queue-card__room">Room ID: {roomId}</p> : null}
                <p className="store-queue-card__time" title={moment(call?.createdAt).format("DD MMM YYYY, hh:mm:ss A")}>
                    Waiting {relativeTime}
                </p>
            </div>
            <div className="store-queue-card__actions">
                <button
                    type="button"
                    className={`store-queue-card__btn store-queue-card__btn--attend ${attendClass}`}
                    onClick={() => onJoin(call, index, false)}
                    aria-label="Attend call"
                >
                    <i className="fa-solid fa-phone" />
                </button>
                <Tooltip anchorSelect={`.${attendClass}`} place="top">Attend Call</Tooltip>
                <button
                    type="button"
                    className={`store-queue-card__btn store-queue-card__btn--reject ${rejectClass}`}
                    onClick={() => onReject(call, index, false)}
                    aria-label="Reject call"
                >
                    <i className="fa-solid fa-phone-slash" />
                </button>
                <Tooltip anchorSelect={`.${rejectClass}`} place="top">Reject Call</Tooltip>
            </div>
        </div>
    );
};

export default StoreQueueCard;
